//Actions
const PURGE = "media/PURGE";
const SET_VIDEO_LIST = "media/SET_VIDEO_LIST";
const SET_VOD_INFO = "media/SET_VOD_INFO";
const SET_VIDEO_PLAYSTATE = "media/SET_STATUS_VIDEO_PLAYSTATE";
const SET_VIDEO_DURATION_TIME = "media/SET_VIDEO_DURATION_TIME";
const SET_PLAY_TIME = "media/SET_PLAY_TIME";
const SET_SELECTED_PLAY_TIME = "media/SET_SELECTED_PLAY_TIME";


// 액션 생성 함수
export const purgeMedia = () => ({ type: PURGE });
export const setVideoList = videoList => ({ type: SET_VIDEO_LIST, videoList });
export const setVodInfo = vodInfo => ({ type: SET_VOD_INFO, vodInfo });
export const setVideoPlayState = videoPlayState => ({ type: SET_VIDEO_PLAYSTATE, videoPlayState });
export const setVideoDurationTime = videoDurationTime => ({ type: SET_VIDEO_DURATION_TIME, videoDurationTime });
export const setPlayTime = playTime => ({ type: SET_PLAY_TIME, playTime });
export const setSelectedPlayTime = selectedPlayTime => ({ type: SET_SELECTED_PLAY_TIME, selectedPlayTime });

// 초깃값 (상태가 객체가 아니라 그냥 숫자여도 상관 없습니다.)
const initialState = {
  videoList: '',
  vodInfo: {},
  videoPlayState: false,
  videoDurationTime: 0,
  playTime: 0,
  selectedPlayTime: 0
};

export default function media(state = initialState, action) {
  switch (action.type) {
    case PURGE:
      return {
        ...initialState
      }
    case SET_VIDEO_LIST:
      return {
        ...state,
        videoList: action.videoList
      }
    case SET_VOD_INFO:
      return {
        ...state,
        vodInfo: action.vodInfo
      }
    case SET_VIDEO_PLAYSTATE:
      return {
        ...state,
        videoPlayState: action.videoPlayState
      }
    case SET_VIDEO_DURATION_TIME:
      return {
        ...state,
        videoDurationTime: action.videoDurationTime
      }
    case SET_PLAY_TIME:
      return {
        ...state,
        playTime: action.playTime
      }
    case SET_SELECTED_PLAY_TIME:
      return {
        ...state,
        selectedPlayTime: action.selectedPlayTime
      }
    default:
      return state;
  }
} 